import { ContactStore } from './store'

export * from './store'
export * from './types'

export const contactStore = ContactStore.new()
export { ContactStore } from './store'
